import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const orderApi = {
  pay (params) {
    return axios.post(
      `${ApiSetting.baseUrl}/api/orders/pay/`,
       querystring.stringify(params)
    )
  },
  episode_list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/orders/episode_list/`,
      {params: params})
  }
}

export default orderApi
